import { render } from "./CustomPopupMenu.vue?vue&type=template&id=96fe09e8"
import script from "./CustomPopupMenu.vue?vue&type=script&lang=js"
export * from "./CustomPopupMenu.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__